import { render } from "./payByUSDT.vue?vue&type=template&id=d5de9ff2"
import script from "./payByUSDT.vue?vue&type=script&lang=js"
export * from "./payByUSDT.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__